import dataFetcher from "../shared/utils/dataFetcher";

function _validateProfileFn(result) {
  // console.log('_validateProfileFn: result = ', result.req)
  if (result.req && result.req.url.length > 0) {
    return true;
  } else {
    return false;
  }
}

function _validatePageLikesFn(result) {
  // console.log('_validatePageLikesFn: result = ', result)
  if (result && result.id.length > 0) {
    return true;
  } else {
    return false;
  }
}

function _validateFeedFn(result) {
  if (result && result.length > 0) {
    return true;
  } else {
    return false;
  }
}

function _validateFbEventFn(result) {
  if (result && result.name.length > 0) {
    // console.log(result.name.length)
    return true;
  } else {
    return false;
  }
}

function _getProfilePic(fetchURL, fetchParams, cache_ttl_min) {
  const maxAgeMinute = cache_ttl_min;

  return dataFetcher
    .getCachedDataForURLParamsMaxAgeMinute(fetchURL, fetchParams, maxAgeMinute)
    .then(function(cachedResult) {
      if (cachedResult) {
        console.log("_getProfilePic: CACHE HIT !!");
        return cachedResult;
      } else {
        // cached not available so fetch from the network
        console.log("_getProfilePic: NETWORK FETCH !!");
        return dataFetcher.fetchThenValidateAndCache(
          fetchURL,
          fetchParams,
          _validateProfileFn
        );
      }
    });
}

function _getPageLikes(fetchURL, fetchParams, cache_ttl_min) {
  const maxAgeMinute = cache_ttl_min;

  return dataFetcher
    .getCachedDataForURLParamsMaxAgeMinute(fetchURL, fetchParams, maxAgeMinute)
    .then(function(cachedResult) {
      if (cachedResult) {
        console.log("_getPageLikes: CACHE HIT !!");
        return cachedResult;
      } else {
        // cached not available so fetch from the network
        console.log("_getPageLikes: NETWORK FETCH !!");
        return dataFetcher.fetchThenValidateAndCache(
          fetchURL,
          fetchParams,
          _validatePageLikesFn
        );
      }
    });
}

function _getFeed(fetchURL, fetchParams, cache_ttl_min) {
  const maxAgeMinute = cache_ttl_min;

  return dataFetcher
    .getCachedDataForURLParamsMaxAgeMinute(fetchURL, fetchParams, maxAgeMinute)
    .then(function(cachedResult) {
      if (cachedResult) {
        console.log("_getFeed: CACHE HIT !!");
        return cachedResult;
      } else {
        // cached not available so fetch from the network
        console.log("_getFeed: NETWORK FETCH !!");
        return dataFetcher.fetchThenValidateAndCache(
          fetchURL,
          fetchParams,
          _validateFeedFn
        );
      }
    });
}

function _getFbEvent(fetchURL, fetchParams, cache_ttl_min) {
  const maxAgeMinute = cache_ttl_min;

  return dataFetcher
    .getCachedDataForURLParamsMaxAgeMinute(fetchURL, fetchParams, maxAgeMinute)
    .then(function(cachedResult) {
      if (cachedResult) {
        console.log("_getFeed: CACHE HIT !!");
        return cachedResult;
      } else {
        // cached not available so fetch from the network
        console.log("_getFeed: NETWORK FETCH !!");
        return dataFetcher.fetchThenValidateAndCache(
          fetchURL,
          fetchParams,
          _validateFbEventFn
        );
      }
    });
}

const dataProvider = {
  validateProfiletFn: _validateProfileFn,
  getProfilePic: _getProfilePic,
  getPageLikes: _getPageLikes,
  getFeed: _getFeed,
  getFbEvent: _getFbEvent
};

export default dataProvider;
